import React from 'react'

function BaseTick ({
  x,
  y,
  fill,
  textAnchor,
  stroke,
  orientation,
  height,
  header = '',
  subtitle = ''
}) {
  return (
    <text
      x={x}
      y={y}
      width={20}
      height={height}
      fill={fill}
      textAnchor={textAnchor}
      stroke={stroke}
      orientation={orientation}
    >
      <tspan
        x={x}
        y={y}
        className='text-sm text-gray-400 fill-current font-medium'
      >
        {header}
      </tspan>
      <tspan
        className='text-sm text-gray-400 fill-current'
        x={x}
        y={y + (header ? 20 : 5)}
      >
        {subtitle}
      </tspan>
    </text>
  )
}

export default React.memo(BaseTick)
